import { OrdersScreen } from '../features/account/OrdersScreen'

export function OrdersPage() {
  return <OrdersScreen />
}
